import { apiPost } from './apiPost'

const loginApi = apiPost('/login')

export default loginApi
